<template>
	<div class="container-wrap">
		<div class="container">
			<div class="aside">
				<asideVideo :current="curNameId" :isAll="isAll" :isShowAll="true" @toList="toList" :menuList="menuList"/>
			</div>
			<div class="content">
				<ul class="list">
					<li v-for="item in dataList" @click="toDetail(item.id)">
						<div class="list-img">
							<img :src="item.picUrl" />
						</div>
						<div class="list-r">
							<div class="list-title">
								<span class="list-btn" v-if="item.topFlag">置顶</span>
								<h3>{{item.title}}</h3>
							</div>
							<div class="list-tips">
								<span class="list-from">作者：{{item.author}}</span>
								<span>发表于{{item.addTime | datefmt('yyyy-MM-DD')}}</span>
							</div>
							<div class="list-txt">
								{{item.introduction}}
							</div>
						</div>
					</li>
				</ul>
				<div class="pagination-wrap">
					<el-pagination
					  background
					  layout="prev, pager, next"
					  :page-size= this.pageSize
					  :total=this.total
					  @current-change="handleCurrentChange"
					  hide-on-single-page
					  >
					</el-pagination>
				</div>
			</div>
			<div class="clearfix"></div>
		</div>
	</div>
</template>
<script>
	import qs from 'qs'
	import asideVideo from '@/components/product/asideVideo'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'Home',
		components: {
			asideVideo
		},
		data() {
			return {
				currentMenu: 0,
				menuList: [],
				id: '',
				categoryIdOne: '',
				categoryIdTwo: '',
				dataList: [],
				pageNum: 1,
				pageSize: 4,
				total: 0,
				curNameId: 0,
				isAll: true
			}
		},
		created(){
			let id = this.$route.params.id
			this.id = id
			this.getCateList()
		},
		watch: {
			$route(to,from) {
				let id = this.$route.params.id
				this.id = id
				this.categoryIdOne = ''
				this.categoryIdTwo = ''
				this.curNameId = 0
				this.pageNum = 1
				this.total = 0
				this.isAll = true
				this.getCateList()
			}
		},
		methods: {
			//获取新闻类型
			async getCateList(){
				let param = {
					id: this.id,
					typeCode: 'news'
				}
				ajaxParam(param)
				const res = await post('v1/category/tree', qs.stringify(param))
				if(res.data.code==200){
					let list = res.data.list
					for(var i=0; i<list.length; i++){
						list[i].isShowChild = true
					}
					this.menuList = list
					this.getDataList()
				} else {
					this.$message.error(res.data.msg)
				}
			},
			//获取当前列表数据
			async getDataList(){
				let param = {
					categoryIdOne: this.categoryIdOne,
					categoryIdTwo: this.categoryIdTwo,
					columnId: this.id,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('v1/news/list', qs.stringify(param))
				if(res.data.code==200){
					this.dataList = res.data.list
					this.total = res.data.total
				} else {
					this.$message.error(res.data.msg)
				}
			},
			handleCurrentChange(e){
				this.dataList = []
				this.pageNum = e
				this.getDataList()
			},
			toList(e){
				this.curNameId = e.id
				console.log(e)
				if(e.parentId) {
					this.categoryIdOne = e.parentId
					this.categoryIdTwo = e.id
				} else{
					this.categoryIdOne = e.id
					this.categoryIdTwo = ''
				}
				if(e.isAll) {
					this.categoryIdOne = ''
					this.categoryIdTwo = ''
				}
				this.isAll = e.isAll
				this.pageNum = 1
				this.total = 0
				this.getDataList()
			},
			toDetail(id){
				this.$router.push({
					path: '/newsDetail/'+this.id+'/'+id
				})
			}
		}
	}
</script>
<style scoped lang="less">
	.container{
		padding: 26px 0 10px;
		.aside{
			float: left;
			width: 280px;
			height: 400px;
			background: #fff;
			.menu{
				li{
					height: 44px;
					padding: 0 23px;
					line-height: 44px;
				}
				li.active{
					background: rgba(222, 5, 21,.1);
					border-right: 4px solid #DE0515;
					color: #000
				}
			}
		}
		.content{
			float: right;
			width: 880px;
			background:#fff;
			padding-top: 0;
			.list{
				padding: 0 24px;
				li{
					display: flex;
					border-bottom: 1px solid #e7e8eb;
					padding: 18px 24px;
					cursor: pointer;
					.list-img{
						width: 176px;
						height: 111px;
						margin-right: 24px;
						border-radius: 4px;
						img{
							width: 100%;
							height: 100%;
						}
					}
					.list-r{
						flex:1;
						.list-title{
							position: relative;
							display: flex;
							span.list-btn{
								display: inline-block;
								padding: 1px 8px;
								margin-right: 7px;
								font-size: 12px;
								border-radius: 3px;
								background-color: #fff;
								border: 1px solid #1075e7;
								color: #1075e7;
								user-select: none;
								cursor: pointer;
								text-align: center;
								line-height: 18px;
								position: absolute;
								left: 0;
								top: 2px;
							}
							h3{
								padding-left: 46px;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
								word-wrap: normal;
								font-size: 18px;
								font-weight: 650;
								line-height: 26px
							}
						}
						.list-tips{
							display: flex;
							align-items: center;
							line-height: 18px;
							margin-top: 9px;
							margin-bottom: 11px;
							font-size: 12px;
							color: #8d8d8e;
							letter-spacing: .86px;
							.list-from{
								display: inline-block;
								color: #333;
								margin-right: 14px;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
								word-wrap: normal;
								max-width: 170px;
							}
						}
						.list-txt{
							font-size: 12px;
							color: #404040;
							text-align: justify;
							line-height: 18px;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 3;
							overflow: hidden;
						}
					}
				}
				li:hover{
					position: relative;
					box-shadow: 0 2px 8px 0 rgba(34, 123, 255, .36);
					border-radius: 6px;
					z-index: 1
				}
			}
		}
	}
</style>
